// +----------------------------------------------------------------------
// | 立减活动相关API接口
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 立减活动分页列表
 * @param {Object} params 查询参数
 * @param {number} params.limit 每页大小
 * @param {string} params.name 活动名称（搜索条件）
 * @param {number} params.page 页码
 * @param {number} params.status 活动状态（1:开始中 2:未开始 3:已结束）
 */
export function getImmediateActivityPage(params) {
  return request({
    url: '/admin/immediate-activity/page',
    method: 'get',
    params: params
  });
}

/**
 * 立减活动详情
 * @param {number} id 活动ID
 */
export function getImmediateActivityDetail(id) {
  return request({
    url: "/admin/immediate-activity/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 新增立减活动
 * @param {Object} data 活动数据
 */
export function createImmediateActivity(data) {
  return request({
    url: '/admin/immediate-activity/create',
    method: 'post',
    data: data
  });
}

/**
 * 更新立减活动
 * @param {number} id 活动ID
 * @param {Object} data 活动数据
 */
export function updateImmediateActivity(id, data) {
  return request({
    url: "/admin/immediate-activity/update",
    method: 'post',
    data: data
  });
}

/**
 * 删除立减活动
 * @param {number} id 活动ID
 */
export function deleteImmediateActivity(id) {
  return request({
    url: "/admin/immediate-activity/delete",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 更新立减活动状态
 * @param {number} id 活动ID
 * @param {number} status 状态值
 */
export function updateImmediateActivityStatus(id, status) {
  return request({
    url: "/admin/immediate-activity/update/status/".concat(id),
    method: 'post',
    data: {
      status: status
    }
  });
}

/**
 * 获取商家列表
 * @param {Object} params 查询参数
 */
export function getSupplierList(params) {
  return request({
    url: '/admin/business/supplier/autoList',
    method: 'get',
    params: params
  });
}

/**
 * 获取油品类型列表
 * @param {Object} params 查询参数
 */
export function getGunList(params) {
  return request({
    url: '/admin/immediate-activity/getGunList',
    method: 'get',
    params: params
  });
}

/**
 * 获取加油站列表（立减活动）
 * @param {Object} params 查询参数
 */
export function getStationList(params) {
  return request({
    url: '/admin/immediate-activity/getStationList',
    method: 'get',
    params: params
  });
}

/**
 * 开启/关闭立减活动
 * @param {number} id 活动ID
 * @param {number} status 状态值
 */
export function enableCloseImmediateActivity(id, status) {
  return request({
    url: '/admin/immediate-activity/enable-close',
    method: 'get',
    params: {
      id: id,
      status: status
    }
  });
}

/**
 * 加油站订单列表
 * @param {Object} params 查询参数
 * @param {number} params.limit 每页大小
 * @param {number} params.page 页码
 * @param {string} params.outTradeNo 商家订单号
 * @param {string} params.orderNo 交易订单号
 * @param {number} params.status 交易状态
 * @param {number} params.supplierId 商家ID
 * @param {string} params.phone 用户手机号
 * @param {string} params.startTime 开始时间
 * @param {string} params.endTime 结束时间
 */
export function getStationOrderList(params) {
  return request({
    url: '/admin/order/station/list',
    method: 'get',
    params: params
  });
}

/**
 * 加油站订单详情
 * @param {string} orderNo 订单号
 */
export function getStationOrderDetail(orderNo) {
  return request({
    url: "/admin/order/station/detail/".concat(orderNo),
    method: 'get'
  });
}

/**
 * 获取福豆使用记录列表
 * @param {string} orderNo 订单号
 */
export function getIntegralLog(orderNo) {
  return request({
    url: "/admin/order/station/getIntegralLog/".concat(orderNo),
    method: 'get'
  });
}

/**
 * 导出加油站订单
 * @param {Object} params 查询参数
 */
export function exportStationOrders(params) {
  return request({
    url: '/admin/order/station/export',
    method: 'get',
    params: params
    // responseType: 'blob'
  });
}